import { motion } from 'framer-motion';
import { useReveal } from '../../hooks/useReveal';
import { useSnapshot } from '../../context/SnapshotContext';
import { ArrowRight } from 'lucide-react';

const ease = [0.22, 1, 0.36, 1];

export function CTA() {
    const ref = useReveal();
    const { openSnapshot } = useSnapshot();

    return (
        <section
            id="cta"
            data-testid="cta-section"
            className="relative section overflow-hidden"
        >
            <div className="atmosphere opacity-80" />
            <div
                className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[80%] mx-6"
                style={{
                    background: 'radial-gradient(ellipse 70% 60% at 50% 50%, rgba(6,182,212,0.12), transparent 70%)',
                }}
            />

            <div className="shell relative">
                <motion.div
                    ref={ref}
                    className="reveal relative card-glass overflow-hidden p-8 sm:p-12 lg:p-20"
                    style={{
                        background: 'linear-gradient(160deg, rgba(6,182,212,0.06), rgba(11,18,33,0.7))',
                        borderColor: 'rgba(6,182,212,0.22)',
                        boxShadow: '0 60px 120px -40px rgba(6,182,212,0.35), 0 0 0 1px rgba(255,255,255,0.04) inset',
                    }}
                    initial={{ opacity: 0, y: 28 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.9, ease }}
                >
                    <div
                        className="pointer-events-none absolute -top-20 -right-20 w-80 h-80 rounded-full"
                        style={{ background: 'radial-gradient(circle, rgba(6,182,212,0.30), transparent 65%)' }}
                    />
                    <div
                        className="pointer-events-none absolute -bottom-20 -left-20 w-72 h-72 rounded-full"
                        style={{ background: 'radial-gradient(circle, rgba(139,92,246,0.20), transparent 65%)' }}
                    />

                    <div className="relative max-w-3xl">
                        <p className="eyebrow">Final · Build the system</p>
                        <h2 className="mt-6 font-display font-semibold text-[2.6rem] sm:text-[4rem] lg:text-[5.4rem] leading-[1.0] tracking-[-0.045em] text-white">
                            Stop losing clients to{' '}
                            <span className="text-gradient-cyan">a website that doesn't work hard enough.</span>
                        </h2>
                        <p className="mt-7 text-[17px] sm:text-[18px] leading-[1.65] text-slate-300 max-w-xl">
                            Start with the snapshot. See what kind of system
                            your business actually needs — and what to fix
                            first. Two minutes. No call. No pitch.
                        </p>

                        <div className="mt-10 flex flex-wrap gap-3">
                            <button
                                type="button"
                                onClick={openSnapshot}
                                data-testid="cta-open-snapshot"
                                className="btn btn-primary"
                            >
                                Find Where You're Losing Clients
                                <ArrowRight className="w-4 h-4" />
                            </button>
                            <a
                                href="mailto:hello@clearadvance.co?subject=Strategy%20Call"
                                data-testid="cta-book-call-button"
                                className="btn btn-ghost"
                            >
                                Book a strategy call
                            </a>
                        </div>
                        <p className="mt-5 font-mono text-[10.5px] tracking-[0.22em] uppercase text-slate-500">
                            2-min diagnostic · Instant clarity · No call required
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
